import { FaCentos, FaDebian, FaDocker, FaFedora, FaNodeJs, FaServer, FaUbuntu, FaWindows, FaWordpress, FaCpanel, FaMagento, FaRedhat, FaBars, FaWhatsapp, FaCircleInfo, FaBookOpen, FaCodeCompare, FaNewspaper, FaBuilding, FaCity, FaGoogle, FaStar, FaCircleCheck } from "react-icons/fa6";
import { SiIntel, SiPlesk, SiPfsense, SiMoodle, SiMikrotik, SiSuse, SiRockylinux, SiAlmalinux, SiProtondrive } from "react-icons/si";
import { RiRecordMailLine, RiContactsFill } from "react-icons/ri";
import { BsAmd, BsFillHddNetworkFill } from "react-icons/bs";
import { IoClose, IoChevronDown, IoPauseSharp, IoPlaySharp } from "react-icons/io5";
import { BiSolidDashboard } from "react-icons/bi";
import Tooltip from "./Tooltip";
const ICON_MAP = {
  ubuntu: FaUbuntu,
  debian: FaDebian,
  rocky: SiRockylinux,
  centos: FaCentos,
  opensuse: SiSuse,
  almalinux: SiAlmalinux,
  fedora: FaFedora,
  "windows-standard-trial": FaWindows,
  rhel: FaRedhat,
  "suse-enterprise-linux": SiSuse,
  wordpress: FaWordpress,
  docker: FaDocker,
  mikrotik: SiMikrotik,
  moodle: SiMoodle,
  nodejs: FaNodeJs,
  cpanel: FaCpanel,
  cyberpanel: FaServer,
  mailcouch: RiRecordMailLine,
  plesk: SiPlesk,
  magento: FaMagento,
  pfsense: SiPfsense,
  'intel-gold': SiIntel,
  'amd-epyc': BsAmd,
  bars: FaBars,
  close: IoClose,
  'chevron-down': IoChevronDown,
  whatsapp: FaWhatsapp,
  info: FaCircleInfo,
  objectStorage: SiProtondrive,
  networking: BsFillHddNetworkFill,
  dashboard: BiSolidDashboard,
  play: IoPlaySharp,
  pause: IoPauseSharp,
  book: FaBookOpen,
  compare: FaCodeCompare,
  paper: FaNewspaper,
  about: FaBuilding,
  contact: RiContactsFill,
  city: FaCity,
  google: FaGoogle,
  star: FaStar,
  check: FaCircleCheck
};

const IconComponent = ({ name, size = 'lg', color = 'text-slate-900 dark:text-slate-200', status = false, tooltipMessage = null }) => {
  const Icon = ICON_MAP[name] || FaServer;

  return (
    <span className="relative inline-flex items-center group">
      <Icon className={`text-${size} ${color} ${status ? 'text-white' : ''}`} aria-hidden="true" />
      {tooltipMessage && <Tooltip tooltipMessage={tooltipMessage} />}
    </span>
  );
};

export default IconComponent;